/**
 * Maintenance Categories and Sub-categories Configuration
 * Used across the application for worker specializations and maintenance categorization
 */

export const MAINTENANCE_CATEGORIES = {
    electrical: {
        name: 'Electrical',
        subcategories: [
            'Wiring and Circuits',
            'Motor Repair',
            'Lighting Systems',
            'Power Distribution',
            'Control Systems',
            'Emergency Power',
            'Electrical Safety',
            'Instrumentation',
            'Power Quality',
            'Electrical Troubleshooting'
        ]
    },
    plumbing: {
        name: 'Plumbing',
        subcategories: [
            'Pipe Installation',
            'Leak Repair',
            'Drain Cleaning',
            'Water Heater Service',
            'Fixture Installation',
            'Valve Repair',
            'Pump Systems',
            'Water Quality',
            'Sewer Systems',
            'Backflow Prevention'
        ]
    },
    hvac: {
        name: 'HVAC',
        subcategories: [
            'Air Conditioning',
            'Heating Systems',
            'Ventilation',
            'Duct Work',
            'Filter Replacement',
            'Thermostat Service',
            'Refrigeration',
            'Air Quality Control',
            'Energy Efficiency',
            'System Diagnostics'
        ]
    },
    general: {
        name: 'General Maintenance',
        subcategories: [
            'Carpentry',
            'Painting',
            'Flooring',
            'Drywall Repair',
            'Window Repair',
            'Door Maintenance',
            'Roof Repair',
            'Masonry',
            'Weatherproofing',
            'General Repairs'
        ]
    },
    cleaning: {
        name: 'Cleaning',
        subcategories: [
            'Janitorial Services',
            'Deep Cleaning',
            'Carpet Cleaning',
            'Window Cleaning',
            'Floor Maintenance',
            'Restroom Sanitation',
            'Waste Management',
            'Pressure Washing',
            'Specialized Cleaning',
            'Cleaning Equipment Maintenance'
        ]
    },
    security: {
        name: 'Security',
        subcategories: [
            'Access Control Systems',
            'CCTV Installation',
            'Alarm Systems',
            'Lock Installation',
            'Security Patrol',
            'Emergency Systems',
            'Key Management',
            'Security Equipment',
            'Surveillance Maintenance',
            'Safety Inspections'
        ]
    }
};

/**
 * Get subcategories for a specific category
 * @param {string} category - The main category
 * @returns {Array} Array of subcategory strings
 */
export const getSubcategories = (category) => {
    return MAINTENANCE_CATEGORIES[category]?.subcategories || [];
};

/**
 * Get all categories
 * @returns {Object} Object with category keys and details
 */
export const getAllCategories = () => {
    return MAINTENANCE_CATEGORIES;
};

/**
 * Get category display name
 * @param {string} category - The category key
 * @returns {string} Display name for the category
 */
export const getCategoryName = (category) => {
    return MAINTENANCE_CATEGORIES[category]?.name || category;
};
